import React, { useEffect, useState } from 'react'
import cx from 'classnames'
import { useDevice } from 'device'
import { formatPrice } from 'helpers'
import { Icon, Text } from 'components/dataDisplay'

import SubscriptionOfferBadge from '../SubscriptionOfferBadge/SubscriptionOfferBadge'

import messages from './messages'

import caseImage from './images/case.png'

import britsheer from './images/products/britsheer.png'
import dkny from './images/products/dkny.png'
import burberry from './images/products/burberry.png'
import dg from './images/products/dg.png'
import dgMan from './images/products/dg-man.png'
import versace from './images/products/versace.png'
import versaceMan from './images/products/versace-man.png'
import gucci from './images/products/gucci.png'
import juicy from './images/products/juicy.png'
import marc from './images/products/marc.png'


const products: Array<{ src: string, price: number }> = [
  {
    src: dg,
    price: 46,
  },
  {
    src: dkny,
    price: 80,
  },
  {
    src: versace,
    price: 85,
  },
  {
    src: britsheer,
    price: 95,
  },
  {
    src: juicy,
    price: 106,
  },
  {
    src: marc,
    price: 62,
  },
  {
    src: gucci,
    price: 128,
  },
  {
    src: burberry,
    price: 93,
  },
  {
    src: dgMan,
    price: 82,
  },
  {
    src: versaceMan,
    price: 92,
  },
]

const imagesCache: Array<HTMLImageElement> = []

type BottlesAnimationBlockProps = {
  className?: string
  offerType: SubscriptionModule.OfferType
  discount?: string
  subscriptionPrice?: string
}

const BottlesAnimationBlock: React.FC<BottlesAnimationBlockProps> = (props) => {
  const { className, offerType, discount, subscriptionPrice } = props

  const { isMobile } = useDevice()
  const [ productIndex, setProductIndex ] = useState(0)

  // Preload images
  useEffect(() => {
    products.forEach((product) => {
      const img = new Image()
      img.src = product.src
      imagesCache.push(img)
    })
  }, [])

  // Change product every interval if the product image is loaded
  useEffect(() => {
    const timer = setTimeout(() => {
      const nextIndex = (productIndex + 1) % products.length
      const img = imagesCache[nextIndex]

      if (img.complete) {
        setProductIndex(nextIndex)
      }
      else {
        img.onload = () => {
          setProductIndex(nextIndex)
        }
      }
    }, 1000)

    return () => {
      clearTimeout(timer)
    }
  }, [ productIndex ])


  const product = products[productIndex]

  return (
    <div className={cx(className, 'flex items-center', isMobile ? 'my-24' : 'absolute right-[100rem] top-1/2 -translate-y-1/2')}>
      <div>
        <img className={isMobile ? 'h-[270rem]' : 'h-[600rem]'} src={product.src} />
        <div className="text-center">
          <Text
            message={messages.productBlock.title}
            style={isMobile ? 'h9' : 'h8'}
          />
          <Text
            className={isMobile ? 'mt-4' : 'mt-8'}
            message={formatPrice(product.price, { isCents: false, removeZeroCents: true })}
            style={isMobile ? 'h6' : 'h3'}
          />
          <Text
            className={isMobile ? 'mt-4' : 'mt-8'}
            message={messages.productBlock.subtitle}
            style={isMobile ? 'p6' : 'p3'}
          />
        </div>
      </div>
      <Icon className={isMobile ? 'mr-16 !h-12 !w-32' : 'mr-64 !h-32 !w-72'} name="other/long-arrow-right" color="gold-50" />
      <div className="relative">
        <img className={isMobile ? 'h-[270rem]' : 'h-[600rem]'} src={caseImage} />
        <div className="text-center">
          <Text
            message={messages.subscriptionBlock.title}
            style={isMobile ? 'h9' : 'h8'}
            color="gold-70"
          />
          <Text
            className={isMobile ? 'mt-4' : 'mt-8'}
            message={subscriptionPrice}
            style={isMobile ? 'h6' : 'h3'}
            color="gold-70"
          />
          <Text
            className={isMobile ? 'mt-4' : 'mt-8'}
            message={messages.subscriptionBlock.subtitle}
            style={isMobile ? 'p6' : 'p3'}
            color="gold-70"
          />
        </div>
        <SubscriptionOfferBadge
          className={cx('absolute', isMobile ? 'bottom-96 left-8 scale-[0.6]' : 'bottom-[120rem] left-[-108rem] scale-[0.8]')}
          offerType={offerType}
          discount={discount}
        />
      </div>
    </div>
  )

}

export default BottlesAnimationBlock
